function wootricInitialize(wootricToken, { callback, createdAt, email, id, planType }) {
  if (!window || !wootricToken) return;

  const createdAtInSeconds = Math.floor(new Date(createdAt)?.getTime() / 1000);

  window.wootricSettings = {
    account_token: wootricToken,
    created_at: createdAt && createdAtInSeconds,
    email,
    external_id: id,
    properties: {
      plan_type: planType,
      product: 'store',
      region: 'br',
    },

    survey_callback: callback,
  };

  const wootricURL = 'https://disutgh7q0ncc.cloudfront.net/beacon.js';

  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');

  script.defer = 'defer';
  script.src = wootricURL;
  script.onload = () => window.wootric('run');
  head.appendChild(script);
}

const Wootric = {
  boot: wootricInitialize,
  getConfig: () => window?.wootricSettings,
};

export default Wootric;
